import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import GetProductName from "../GetProductName";
import "./Orders.css";
import Sellernav from "../Sellernav";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const Orders = () => {
  const updateDispatch = async (props1, props2, props3) => {
    axios.post(
      `${BaseURL}UpdateDispatch?id=${props1}&pid=${props2}`,
      {},
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Product Dispatched", "success");
    document.getElementById(props3).style.display = "none";
  };

  const [orders, setOrders] = useState();
  async function getOrders() {
    const r = await axios.get(
      `${BaseURL}OrderItems?name=${sessionStorage.getItem("user")}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    setOrders(r.data);
  }
  useEffect(() => {
    getOrders();
  }, []);
  return (
    <>
      <Sellernav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo">
            <h1 className="font-weight-bold">Sales Report</h1>
          </div>
        </div>
      </section>
      <section className="">
        <div className="container">
          <div className="cart">
            <div className="table-responsive">
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Latest Orders
                    </th>
                  </tr>
                </thead>
              </table>
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Product
                    </th>
                    <th scope="col" className="text-white">
                      Order Number
                    </th>
                    <th scope="col" className="text-white">
                      Price
                    </th>
                    <th scope="col" className="text-white">
                      Quantity
                    </th>
                    <th scope="col" className="text-white">
                      Total
                    </th>
                    <th scope="col" className="text-white">
                      Dispatch Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders
                    ? orders.map((data,key) =>
                        data.acceptance === false ? (
                            <tr key={key} id={data.id} className="target">
                              <td>
                                <GetProductName props={data.product_id} />
                              </td>
                              <td>{data.ordernumber}</td>
                              <td className="price">{data.price}</td>
                              <td className="quantity">{data.quantity}</td>
                              <td className="total">
                                {data.quantity * data.price}
                              </td>
                              <td className="total">
                                <i
                                  className="fas fa-check accept"
                                  onClick={() =>
                                    updateDispatch(
                                      data.ordernumber,
                                      data.product_id,
                                      data.id
                                    )
                                  }
                                ></i>
                              </td>
                            </tr>
                        ) : (
                          <></>
                        )
                      )
                    : ""}
                </tbody>
              </table>
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Dispatched Orders
                    </th>
                  </tr>
                </thead>
              </table>
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Product
                    </th>
                    <th scope="col" className="text-white">
                      Order Number
                    </th>
                    <th scope="col" className="text-white">
                      Price
                    </th>
                    <th scope="col" className="text-white">
                      Quantity
                    </th>
                    <th scope="col" className="text-white">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders
                    ? orders.map((data,key) =>
                        data.acceptance === true ? (
                            <tr key={key} id={data.id} className="target">
                              <td>
                                <GetProductName props={data.product_id} />
                              </td>
                              <td>{data.ordernumber}</td>
                              <td className="price">{data.price}</td>
                              <td className="quantity">{data.quantity}</td>
                              <td className="total">
                                {data.quantity * data.price}
                              </td>
                            </tr>
                        ) : (
                          <></>
                        )
                      )
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Orders;
